module.exports = __webpack_public_path__ + "static/assets/b78dd25380ef8465606e0b06fd043391.svg";